define [], () ->
  ($scope, $uibModalInstance, RentappService, $http, context, pid_data, RENTAPPLICATION_API_URL) ->
    if __DEBUG__
      $scope.pid_data =
        #firstName:       "PEGGY"
        #lastName:        "BEDFORD"
        #ssn:             "666178053"
        #currentAddress:  "RR 1 BOX 8"
        #currentCity:     "CANTON"
        #currentState:    "PA"
        #currentZip:      "17724"
         firstName:       "Akkaya"
         lastName:        "Jorge"
         ssn:             "666720909"
         currentAddress:  "32 brook st"
         currentCity:     "Patchogue"
         currentState:    "NY"
         currentZip:      "11772"
    if pid_data
      $scope.pid_data = pid_data
    $scope.verification_type = context

    $scope.begin_experian_questions_and_answers = () ->
      $scope.experian_get_questions_error_message = null
      $scope.loading_questions = true
      $http.get "#{RENTAPPLICATION_API_URL}/api/v1/reportsourceprofile/experian_questions/?#{context}=true", params: $scope.pid_data
      .then (response) ->
        $uibModalInstance.close(response.data)
      .catch (response) ->
        $scope.error = response.data
        if response.data.code == "max_attempts_reached"
          $uibModalInstance.dismiss("failure")
      .finally () ->
        $scope.loading_questions = false

    $scope.close_modal = () ->
      $uibModalInstance.dismiss("failure")



// WEBPACK FOOTER //
// ./services/experian/beginExperianVerification/beginExperianVerification.coffee